module.exports = __webpack_public_path__ + "static/media/creditCardLogo.28476ec1.svg";